module.exports = __webpack_public_path__ + "static/img/cashierOrderAD.eaed72a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/cashierOrderAD.png
// module id = GXC6
// module chunks = 1